/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Sälj eller dela inte mina personuppgifter",
      "Bumble Date",
      "Våra appar",
      "Om",
      "Lediga jobb",
      "Kontakta oss",
      "Investerare",
      "Butiken",
      "Företag",
      "Ladda ned appen",
      "Tillgänglighet på Bumble",
      "Riktlinjer",
      "Hantera cookies",
      "Modern Slavery act",
      "Meddelande om insamling",
      "Sekretesspolicy",
      "Villkor och regler",
      "Juridisk information",
      "Sekretesspolicy för konsumenters hälsodata i delstaten Washington",
      "Scanna QR-koden för att hämta Bumble-appen",
      "Avsluta avtal här",
      "Stäng meny",
      "Öppna meny",
      "Val av språk",
      "Sidfot",
      "Tillgänglighet på Bumble",
      "Apple och logotypen för Apple är varumärken som tillhör Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Lediga jobb",
      "Google Play är ett varumärke som tillhör Google LLC.",
      "Riktlinjer",
      "Investerare",
      "Hantera cookies",
      "Modern Slavery Act Statement",
      "Meddelande om insamling",
      "Sekretesspolicy",
      "Dejtidéer för varje årstid",
      "Villkor och regler",
      "Appen",
      "Sekretesspolicy för konsumenters hälsodata i delstaten Washington",
      "Om",
      "Ambassadörer",
      "Träffa vänner och bli del av en gemenskap",
      "Nätverka och gör framsteg inom karriären",
      "Hitta ett förhållande, något lättsamt eller något mitt emellan.",
      "The Buzz",
      "Läs mer",
      "Swipa över hela världen med Travel-läge",
      "Date",
      "Funktioner",
      "Compliments",
      "Stick ut från mängden med Compliments.",
      "Upptäck",
      "En personlig sida som visar dina mest kompatibla personer, och uppdateras dagligen.",
      "Inkognito-läge",
      "Dölj din profil från ditt ex, släkten eller chefen med Inkognito-läget.",
      "Matcha direkt",
      "Börjat snacka på ett Bumble-event? Fortsätt i appen.",
      "Opening Moves",
      "Låt din matchning starta chatten med Opening Moves.",
      "Snooze-läge",
      "Pausa dejtandet med Snooze-läget. Vi finns här när du är redo att komma igång igen.",
      "SuperSwipe",
      "Fastnat för någon? Visa hur du känner med en SuperSwipe.",
      "Travel-läge",
      "Dejta och matcha var som helst i världen med Travel-läget.",
      "Videosamtal",
      "Ring video- och röstsamtal för att se om ni är redo att träffas personligen.",
      "Webbappen",
      "Få Bumble-upplevelsen direkt från din webbläsare.",
      "Skaffa Bumble-appen",
      "BFF",
      "Säkerhet",
      "Berättelser",
      "Support",
      "Shop",
      "Huvudmeny",
      "Skicka lite komplimanger och stick ut från mängden.",
      "Compliments",
      "Funktioner som bäddar för äkta, respektfulla och meningsfulla kontakter.",
      "Dölj din profil från exet, släkten eller chefen.",
      "Inkognito-läge",
      "Pausa dejtandet med Snooze-läget.",
      "Snooze-läge",
      "Sett någon du gillar? Visa det.",
      "SuperSwipe",
      "Utforska Date",
      "Dejta och matcha var som helst i världen.",
      "Travel-läge",
      "Kom så nära IRL som möjligt utan att lämna hemmet.",
      "Videosamtal",
      "Våra ambassadörer hjälper till att sprida Bumbles värderingar in i sina områden landet över.",
      "Ambassadörer",
      "Funktioner som tagits fram för att hjälpa dig hitta sådana som du, och bonda över det ni är intresserade av.",
      "Ordna en gruppträff eller upptäck evenemang i närheten.",
      "Plans",
      "Utforska BFF",
      "All vägledning och inspiration du behöver för att hitta kärlek och vänskap.",
      "Råd och berättelser som hjälper dig att skapa de relationer du vill ha.",
      "Vänskapscentret",
      "Från Tokyo till Toronto – läs om Bumble-kärlek runt om i världen.",
      "Kärlekshistorier",
      "Planera den perfekta dejten, oavsett när, var eller vem du dejtar.",
      "Dejtidéer för varje årstid",
      "Utforska berättelser",
      "Läs mer",
      "Bumble på {{social_network}}",
      "Kontakta oss",
      "Logga in",
      "(opens in new window)",
      "Vanliga frågor",
      "Cookie Policy",
      "Bumble – The Blog",
      "Lediga jobb",
      "Chatt",
      "Städer",
      "Hantera cookies",
      "Copyright © 2006 – dagens datum. Bumble. Alla rättigheter förbehålls.",
      "Rapport om dejting och trygghet",
      "Apple och logotypen för Apple är varumärken som tillhör Apple Inc.{{__EOL__}}Google Play är ett varumärke som tillhör Google LLC.",
      "Ladda ner",
      "Facebook",
      "Följ oss",
      "Hjälpcenter",
      "Instagram",
      "Språk",
      "LinkedIn",
      "Bumble är del av Bumble Inc.",
      "Sekretesspolicy",
      "Säkerhetscenter",
      "Webbplatskarta",
      "Uttalande om Modern Slavery Act",
      "Villkor och regler",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dagar",
                  "dagars"
            ],
            "singular": [
                  "dag",
                  "dags"
            ]
      },
      "hour": {
            "plural": [
                  "timmar",
                  "timmars"
            ],
            "singular": [
                  "timme",
                  "timmes"
            ]
      },
      "minute": {
            "plural": [
                  "minuter",
                  "minuters"
            ],
            "singular": [
                  "minut",
                  "minuts"
            ]
      },
      "month": {
            "plural": [
                  "månader",
                  "månaders"
            ],
            "singular": [
                  "månad",
                  "månads"
            ]
      },
      "second": {
            "plural": [
                  "sekunder",
                  "sekunders"
            ],
            "singular": [
                  "sekund",
                  "sekunds"
            ]
      },
      "year": {
            "plural": [
                  "år",
                  "års"
            ],
            "singular": [
                  "år",
                  "års"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
